import { useEffect, useState, useRef, Fragment } from "react";
import {
  getCombos,
  getAportes,
  setAporte,
  setPlantillaSencilla,
  updateProyectoAportantes,
} from "../componentes/api.js";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import {
  Alert,
  AlertTitle,
  Divider,
  FormGroup,
  FormControlLabel,
  Switch,
  TextField,
} from "@mui/material";
import BarraBotones from "../comun/BarraBotones.jsx";
import { FaFileMedical } from "react-icons/fa";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Table from "react-bootstrap/Table";

const Aportantes = (props) => {
  const testRef = useRef(null);
  const [cant, setCant] = useState(0);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [empresas, setEmpresas] = useState([]);
  const [aportes, setAportes] = useState([]);
  const [datos, setDatos] = useState({
    id: "",
    idProyecto: props.idProyecto,
    idAportante: "",
    activo: true,
    monto: 0,
    idUsuario: props.idUsuario,
  });

  /** Para el manejo de la ventana de creación de tipos de proyectos**/
  const [mostrarCrear, setMostrarCrear] = useState(false);

  useEffect(() => {
    cargarCombos({ Tabla: "aportantes", Campo: "" }, "idAportante");
    if (props.idProyecto !== "") {
      setDatos({ ...datos, ["idProyecto"]: props.idProyecto });
      cargarAportes();
    }
  }, [props.idProyecto]);

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "activo") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
    }
  };

  const botones = (btn) => {
    if (btn === 0) {
      nuevo();
    } else if (btn === 1) {
      validarDatos();
    } else if (btn === 3) {
      exportar();
    } else if (btn === 4) {
      nuevo();
    }
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      const response = await getCombos(datos);
      setEmpresas(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarAportes = async () => {
    try {
      const response = await getAportes(props.idProyecto);
      setAportes(response.data);
      setCant(response.data.length);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Aportes",
        error,
      ]);
    }
  };

  const cerrarVentanaCrear = () => {
    setMostrarCrear(false);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const grabarCampo = async (nbre) => {
    try {
      let plantilla = {
        tabla: "aportantes",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario,
      };
      const response = await setPlantillaSencilla(plantilla);
      setDatos({ ...datos, idAportante: response.data.Id });
      cargarCombos({ Tabla: "aportantes", Campo: "" }, "aportantes");
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar La Empresa Aportante!",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      const response = await setAporte(datos);
      cargarAportes();
      props.mostrarMsg([
        "Felicidades!!!",
        "Se ha creado el aporte de la empresa al Proyecto",
      ]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el aporte de la empresa al Proyecto ",
        error,
      ]);
    }
  };

  const mostrarRegistro = async (reg) => {
    setDatos({
      ...datos,
      id: reg.Id,
      idProyecto: props.idProyecto,
      idAportante: reg.IdAportante,
      monto: reg.Monto,
      activo: reg.Activo === "Activo" ? true : false,
      idUsuario: props.idUsuario,
    });
    scrollToElement();
  };

  const mostrarVentanaCrear = (event) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const modificarRegistro = async () => {
    try {
      await updateProyectoAportantes(datos);
      cargarAportes();
      props.mostrarMsg(["Aportes Modificado!"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar los Aportes del Proyecto",
        error,
      ]);
    }
  };

  const nuevo = () => {
    setDatos({
      id: "",
      idProyecto: props.idProyecto,
      idAportante: "",
      activo: true,
      monto: 0,
      idUsuario: props.idUsuario,
    });
  };

  const validarDatos = () => {
    if (props.idProyecto === "") {
      props.mostrarMsg(["Por favor digite el Nombre del Proyecto"]);
    } else if (datos.idAportante === "") {
      props.mostrarMsg([
        "Por favor seleccione La Empresa que realiza el Aporte al Proyecto",
      ]);
    } else if (datos.monto === "" || datos.monto === 0) {
      props.mostrarMsg(["Por favor digite el Monto del Aporte al Proyecto"]);
    } else {
      if (datos.id === "") {
        grabarRegistro();
      } else {
        modificarRegistro();
      }
    }
  };

  return (
    <>
      <Fragment>
        <div className="container-fluid mt-2" ref={testRef}>
          <div className="row card">
            <Alert severity="success">
              <AlertTitle>
                <strong>EMPRESAS APORTANTES AL PROYECTO</strong>
              </AlertTitle>
              Seleccione la entidad que aporta los recursos financieros y digite
              la cantidad que aporta
            </Alert>

            <div className="row mb-3 mt-3">
              <div className="row input-group form-floating mt-3">
                <div className="col-sm-8">
                  <div className="input-group form-floating mt-2">
                    <select
                      name="idAportante"
                      className="form-select form-control"
                      id="idAportante"
                      aria-label="idAportante"
                      value={datos.idAportante}
                      onChange={(event) => asignarDato(event)}
                    >
                      <option key="0" value="0">
                        Seleccione una Empresa Aportante...
                      </option>
                      {empresas.map((reg) => {
                        return (
                          <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                            {" "}
                            {reg.Nbre}{" "}
                          </option>
                        );
                      })}
                    </select>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={(event) => {
                        mostrarVentanaCrear(event);
                      }}
                    >
                      <FaFileMedical />
                    </button>
                  </div>
                </div>

                <div className="col-sm-4">
                  <TextField
                    style={{ marginTop: "10px" }}
                    InputLabelProps={{ shrink: true }}
                    id="monto"
                    name="monto"
                    label="Monto Aportado $"
                    className="form-control"
                    onChange={(event) => asignarDato(event)}
                    type="number"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    step="1000000"
                    value={datos.monto}
                    InputProps={{
                      startAdornment: (
                        <AttachMoneyIcon position="start">$</AttachMoneyIcon>
                      ),
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      min: 0,
                      type: "number",
                      step: 1000000,
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <FormGroup>
                <FormControlLabel
                  name="activo"
                  control={
                    <Switch
                      checked={datos.activo}
                      onChange={asignarDato}
                      inputProps={{ "aria-label": "Activo" }}
                    />
                  }
                  label={
                    datos.activo === true
                      ? "Estado: Aportante ACTIVO"
                      : "Estado: Aportante ANULADO"
                  }
                  labelPlacement="start"
                />
              </FormGroup>
            </div>
          </div>

          <Divider component="ul" />
          <div className="row mt-3">
            <BarraBotones
              botones={botones}
              btnActivos={[true, true, false, true, true]}
            />
          </div>
          <Divider component="ul" />

          <div className="row mt-3">
            <div className="row mt-2">
              <h3>Listado de Entidades Aportantes - Cantidad: {cant}</h3>
              <Table className="table table-hover table-bordered" responsive>
                <thead className="table-primary">
                  <tr>
                    <th scope="col"># Item</th>
                    <th scope="col">Empresa Aportante</th>
                    <th scope="col">Monto</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {aportes.map((reg, i) => {
                    return (
                      <tr
                        className={
                          reg.Activo === "Inactivo" ? "table-danger" : ""
                        }
                        key={i}
                      >
                        <th> {i + 1} </th>
                        <th> {reg.NbreAportante} </th>
                        <th> {reg.Monto} </th>
                        <th> {reg.Activo} </th>
                        <th>
                          <a href="#divTop">
                            <button
                              className="btn btn-primary form-control"
                              onClick={(event) => {
                                mostrarRegistro(reg);
                              }}
                            >
                              Editar
                            </button>
                          </a>
                        </th>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          {mostrarCrear === true && (
            <VentanaCrear
              titulo={"ENTIDAD APORTANTE"}
              grabarCampo={grabarCampo}
              mostrarCrear={mostrarCrear}
              setMostrarCrear={setMostrarCrear}
            />
          )}
        </div>
      </Fragment>
    </>
  );
};

export default Aportantes;
